import { XIcon } from 'lucide-react';

import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';
import { Stack } from '@/ux-common/components/stack/stack';

import { IconWithTooltip } from './icon-wrapper';

export const RemoveStageButton = ({ onClick }: { onClick: () => void }) => {
  const { isDisabled: disabledByPermissions, tooltipText } = useActionPermission({
    privilege: PRIVILEGES.writeCommands,
  });

  return (
    <div className={'absolute top-0 right-1 h-full flex items-center justify-center'}>
      <IconWithTooltip
        icon={XIcon}
        isDisabled={disabledByPermissions}
        delayDuration={0}
        onClick={() => {
          if (!disabledByPermissions) {
            onClick();
          }
        }}
        tooltipContent={
          <Stack className="stack-thin">
            <span className="font-bold">{'Remove Stage'}</span>
            <span>{disabledByPermissions ? tooltipText : undefined}</span>
          </Stack>
        }
      />
    </div>
  );
};
